import React from 'react';
import cx from 'classnames';
import WithSX from '../../hoc/WithSX';
import { propTypes, defaultProps } from './props';

/**
 * @component Flex
 */
import { jsx as ___EmotionJSX } from "@emotion/react";
const Flex = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    children,
    dir,
    className,
    sx,
    onClick,
    onFocus,
    onBlur,
    onMouseEnter,
    onMouseLeave
  } = props;
  return ___EmotionJSX("div", {
    dir: dir,
    ref: ref,
    css: sx,
    className: cx('flex', className),
    onClick: onClick,
    onFocus: onFocus,
    onBlur: onBlur,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, children);
});
Flex.displayName = 'Flex';
Flex.propTypes = propTypes;
Flex.defaultProps = defaultProps;
export default WithSX(Flex, {});